import { host } from '../API';

export const updateAppThreshold = async function (app: string, threshold: number, token: string): Promise<any> {
    const endpoint = host + `apps/${app}/updateThreshold`;

    const response = await fetch(
        endpoint,
        {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                'threshold': threshold
            })
        });

    if (!response.ok) {
        const message = 'Failed to update app threshold. Please try again or contact support.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
};

export const searchIOSApp = async function (query: string, token: string) {
    const endpoint = host + `apple/search?${query}`;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        });

    if (!response.ok) {
        const message = 'Failed to search iOS apps. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
};

export const searchAndroidApp = async function (query: string, token: string) {
    const endpoint = host + `android/search?${query}`;

    const response = await fetch(
        endpoint,
        {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-type': 'application/json'
            }
        });

    if (!response.ok) {
        const message = 'Failed to search Android apps. Please check your connection and try again.';
        throw new Error(message);
    }

    const results = await response.json();

    return results;
};